import {
  TrustMarkers,
  AwardTrustMarker,
  TrustMarkerType,
} from "@interfaces/trust-markers.types";
import { TrustMarkersCollection } from "@interfaces/car-api.types";

const TRUST_MARKER_PRIORITY = {
  [TrustMarkerType.NEWLY_LAUNCHED]: 1,
  [TrustMarkerType.BEST_SELLER]: 2,
  [TrustMarkerType.MOST_VIEWED]: 3,
  [TrustMarkerType.MOST_SEARCHED]: 4,
};

// Priority map for collection API trust markers (case-insensitive matching)
const COLLECTION_TRUST_MARKER_PRIORITY: Record<string, number> = {
  "newly launched": 1,
  "best seller": 2,
  "most viewed": 3,
  "most searched": 4,
};

export const getHighestPriorityTrustMarker = (
  trustMarkers?: TrustMarkers
): string | null => {
  if (!trustMarkers?.dynamicTrustmarkerTags?.length) {
    return null;
  }

  let highestPriorityMarker: string | null = null;
  let highestPriority = Infinity;

  trustMarkers?.dynamicTrustmarkerTags?.forEach((tag) => {
    const tagName = tag?.tagName;
    const priority = TRUST_MARKER_PRIORITY?.[tagName as TrustMarkerType];

    if (priority && priority < highestPriority) {
      highestPriority = priority;
      highestPriorityMarker = tagName;
    }
  });
  if (
    !highestPriorityMarker &&
    trustMarkers?.dynamicTrustmarkerTags?.length > 0
  ) {
    highestPriorityMarker = trustMarkers?.dynamicTrustmarkerTags?.[0]?.tagName;
  }

  return highestPriorityMarker;
};

export const hasAwardTrustMarkers = (trustMarkers?: TrustMarkers): boolean => {
  return !!(
    trustMarkers?.awardTrustmarkers &&
    trustMarkers?.awardTrustmarkers?.length > 0
  );
};

export const getAwardTrustMarkers = (
  trustMarkers?: TrustMarkers
): AwardTrustMarker[] => {
  return trustMarkers?.awardTrustmarkers || [];
};

export const getLatestAwardTrustMarkers = (
  trustMarkers?: TrustMarkers,
  limit: number = 3
): AwardTrustMarker[] => {
  const awards = getAwardTrustMarkers(trustMarkers);

  return awards
    .sort((a, b) => parseInt(b.awardYear) - parseInt(a.awardYear))
    .slice(0, limit);
};

export const getHighestPriorityTrustMarkerCollection = (
  trustMarkers?: TrustMarkersCollection | null
): string | null => {
  if (!trustMarkers?.dynamic_trustmarker_tags?.length) {
    return null;
  }

  let highestPriorityMarker: string | null = null;
  let highestPriority = Infinity;

  trustMarkers?.dynamic_trustmarker_tags?.forEach((tag) => {
    const tagName = tag?.tag_name?.toLowerCase();
    const priority = COLLECTION_TRUST_MARKER_PRIORITY?.[tagName];

    if (priority && priority < highestPriority) {
      highestPriority = priority;
      highestPriorityMarker = tag?.tag_name;
    }
  });
  if (
    !highestPriorityMarker &&
    trustMarkers?.dynamic_trustmarker_tags?.length > 0
  ) {
    highestPriorityMarker =
      trustMarkers?.dynamic_trustmarker_tags?.[0]?.tag_name;
  }

  return highestPriorityMarker;
};
